import React, { useCallback } from 'react';
import { CircledEnvelopeIcon } from '@components/icons/icons/CircledEnvelopeIcon';
import { Trans, useTranslation } from 'react-i18next';
import { Button, Divider } from '@mui/material';
import { themeColors } from '@styles/theme';
import { Link } from 'react-router-dom';
import './check-email-page.scss';
import { AuthPagesWrapper } from '@components/AuthPagesWrapper/AuthPagesWrapper';
import BackToSignInButton from '@components/BackToSignInButton/BackToSignInButton';
import { useToastContext } from '@context/toastContext';
import { debounce } from 'lodash';

type Props = {
    email: string;
    resendFn: (email: string) => Promise<void>;
};

const CheckEmailPage = ({ email, resendFn }: Props) => {
    const { t } = useTranslation();
    const { addToast } = useToastContext();

    const handleResend = useCallback(
        debounce(async () => {
            await resendFn(email);
            addToast(`${t('check-email-page.resend-success')}`, 'success');
        }, 1000),
        [email, addToast]
    );

    return (
        <AuthPagesWrapper showLogoColumn={false}>
            <div className="check-email-page__row check-email-page__icon">
                <CircledEnvelopeIcon />
            </div>
            <h1 className="check-email-page__row check-email-page__title">
                {t('check-email-page.title')}
            </h1>
            <p className="check-email-page__row check-email-page__description">
                {t('check-email-page.description')}&nbsp;
                <span className="check-email-page__content_bold">{email}</span>
            </p>
            <p className="check-email-page__row check-email-page__resend-msg">
                <Trans i18nKey="check-email-page.click-to-resend-msg">
                    Didn’t receive the e-mail?
                    <Link className="check-email-page__content_bold" to="#" onClick={handleResend}>
                        Click to resend
                    </Link>
                </Trans>
            </p>
            <Divider />
            <div className="check-email-page__row check-email-page__buttons">
                <BackToSignInButton title={t('reset-password-form.back-to-login-link')} />
                <a href="mailto:">
                    <Button
                        type="submit"
                        variant="contained"
                        style={{ background: themeColors.purple }}
                    >
                        {t('check-email-page.button')}
                    </Button>
                </a>
            </div>
        </AuthPagesWrapper>
    );
};

export default CheckEmailPage;
